//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Navigation Bar component
//
//  Copyright:    © 2021 - 2026 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//region Version 1.0.0.0
//    001   02.07.21 Sean Flook          WI39??? Initial Revision.
//    002   28.06.23 Sean Flook          WI40256 Changed Extent to Provenance where appropriate.
//    003   03.07.23 Sean Flook                  Hide Users & permissions, Export and Import options.
//    004   17.08.23 Sean Flook        IMANN-156 Modified to allow the login dialog to be displayed again after user has clicked cancel.
//    005   06.10.23 Sean Flook                  Use colour variables.
//    006   27.10.23 Sean Flook                  Updated call to SavePropertyAndUpdate.
//    007   10.11.23 Sean Flook                  Modified call to StringAvatar.
//    008   24.11.23 Sean Flook                  Moved Stack to @mui/system and pass the correct parameter to StringAvatar.
//    009   05.01.24 Sean Flook                  Changes to sort out warnings and use CSS shortcuts.
//    010   29.01.24 Sean Flook        IMANN-262 Changed from a Popper control to a Popover control, so we can handle closing when clicking away.
//    011   29.01.24 Sean Flook        IMANN-262 Do not display the users settings card if no user is logged in.
//    012   30.01.24 Sean Flook                  Updated to use new Idox logo.
//    013   05.02.24 Sean Flook                  Tweaked position of logo.
//    014   16.02.24 Sean Flook         ESU16_GP If changing page etc ensure the information and selection controls are cleared.
//    015   05.03.24 Sean Flook        IMANN-338 Check for changes when clicking any of the buttons which would cause to navigate away from a record.
//    016   07.03.24 Sean Flook        IMANN-338 Always clear any errors if we are leaving the current page.
//    017   08.03.24 Sean Flook        IMANN-348 Use the new hasStreetChanged and hasPropertyChanged methods as well as updated calls to ResetContexts.
//    018   08.03.24 Sean Flook        IMANN-338 If the save fails do not leave the current page.
//    019   11.03.24 Sean Flook            GLB12 Correctly set widths.
//    020   22.03.24 Sean Flook            GLB12 Changed to use dataFormStyle so height can be correctly set.
//    021   10.06.24 Sean Flook        IMANN-509 Allow a user to change their password.
//    022   19.06.24 Sean Flook        IMANN-629 Changes to code so that current user is remembered and a 401 error displays the login dialog.
//    023   20.06.24 Sean Flook        IMANN-636 Use the new user rights.
//    024   21.06.24 Sean Flook        IMANN-642 Changes required to redisplay the change password dialog after previously cancelling out.
//    025   24.06.24 Sean Flook        IMANN-170 Changes required for cascading parent PAO changes to children.
//    026   04.07.24 Sean Flook        IMANN-705 Use displayName for the user icon.
//    027   15.07.24 Sean Flook        IMANN-762 If user cannot see properties default to street template when opening the settings.
//endregion Version 1.0.0.0
//region Version 1.0.1.0
//    028   24.10.24 Sean Flook       IMANN-1040 Call the logoff endpoint when logging a user off the system.
//    029   07.01.25 Joshua McCormick IMANN-1050 Initial Check Notifications with changeset 65608
//endregion Version 1.0.1.0
//region Version 1.0.4.0
//    030   11.02.25 Sean Flook       IMANN-1680 Set the search string when clicking on the gazetteer button and we do not already have one.
//    031   12.02.25 Sean Flook       IMANN-1684 Changes required to set the map extent to the authorities extent when returning to the gazetteer page with no search results.
//    032   12.02.25 Sean Flook       IMANN-1684 Clear data as well.
//endregion Version 1.0.4.0
//region Version 1.0.5.0
//    033   27.01.25 Sean Flook       IMANN-1077 Upgraded MUI to v6.
//endregion Version 1.0.5.0
//region Version 1.0.6.1
//    034   02.09.25 Sean Flook       IMANN-2011 If a parent has been moved ask user if they also want to move its children as well.
//endregion Version 1.0.6.1
//region Version 1.0.7.0
//    035   13.06.25 Sean Flook       IMANN-1812 Modified to use the new Sandbox store.
//    036   28.08.25 Sean Flook       IMANN-1812 Changes required to update MUI to v7.
//    037   01.09.25 Sean Flook       IMANN-1812 Changes required to update React-Router-Dom to v6.
//    038   04.09.25 Sean Flook       IMANN-1812 Changes required to replace React-Router-Dom with React_Router v7.8.2.
//    039   17.12.25 Sean Flook       IMANN-2196 Removed the information component as no longer required in this control.
//    040   17.12.25 Sean Flook       IMANN-2197 Correctly call resetSandbox.
//    041   12.01.26 Josh McCormick   IMANN-1050 Implemented view notification logic.
//    042   15.01.26 Josh McCormick   IMANN-1050 Notification styling and compile error fix
//    043   15.01.26 Josh McCormick   IMANN-1050 Notification styling, datetime change
//    043   15.01.26 Josh McCormick   IMANN-2203 Notification card font weight changes
//    044   26.01.26 Josh McCormick              Removed duplicate notification error logging and fixed check
//    045   16.02.26 Josh McCormick   IMANN-1050 Notification api call 'imanage cloud' not 'imanage', unneeded validation removed
//    046   20.02.26 Sean Flook       IMANN-2329 Updated call to resetPropertyErrors.
//    047   04.03.26 Josh McCormick   IMANN-2332 Notification api call now using 'iManage GMS'.
//    048   19.03.26 Josh McCormick   IMANN-2365, 2366, 2367 Notification styling, hyperlink placement, date display fixes.
//    049   23.03.26 Sean Flook       IMANN-2369 Removed unnecessary code.
//    050   31.03.26 Josh McCormick   IMANN-2379 Polling interval for notifications changed to 30 minutes, fixed api spam.
//    051   10.04.26 Josh McCormick   IMANN-2367 Notification row layout, read text not faded, unread hover pale blue.
//endregion Version 1.0.7.0
//
//--------------------------------------------------------------------------------------------------
//endregion header

//region imports

import React, { useContext, useState, useRef, useEffect, useCallback, Fragment } from "react";
import { useNavigate, useLocation } from "react-router";

import useSandboxStore from "../context/SandboxStore";

import StreetContext from "../context/streetContext";
import PropertyContext from "../context/propertyContext";
import SearchContext from "../context/searchContext";
import MapContext from "../context/mapContext";
import LookupContext from "../context/lookupContext";
import UserContext from "../context/userContext";
import SettingsContext from "../context/settingsContext";
import InformationContext from "../context/informationContext";

import {
  StringAvatar,
  stringToSentenceCase,
  ResetContexts,
  FormatTime,
  blankGazetteerSearchString,
} from "../utils/HelperUtils";
import {
  GetCurrentStreetData,
  SaveStreet,
  HasStreetChanged,
  getChangedAssociatedStreetRecords,
} from "../utils/StreetUtils";
import {
  GetCurrentPropertyData,
  SavePropertyAndUpdate,
  hasParentPaoChanged,
  hasParentMoved,
  HasPropertyChanged,
  getChangedAssociatedPropertyRecords,
} from "../utils/PropertyUtils";
import { useSaveConfirmation } from "../pages/SaveConfirmationPage";
import {
  Tooltip,
  Drawer,
  Grid,
  IconButton,
  Snackbar,
  Alert,
  Popover,
  Typography,
  Card,
  CardActions,
  CardContent,
  Avatar,
  Box,
  Stack,
} from "@mui/material";
import ADSActionButton from "./ADSActionButton";

import DashboardIcon from "@mui/icons-material/Dashboard";
import ExploreIcon from "@mui/icons-material/Explore";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ADSWhatsNewAvatar from "./ADSWhatsNewAvatar";
import ADSNotificationsAvatar from "./ADSNotificationsAvatar";
import ADSUserAvatar from "./ADSUserAvatar";
import CircleIcon from "@mui/icons-material/Circle";

import {
  HomeRoute,
  GazetteerRoute,
  StreetRoute,
  PropertyRoute,
  TaskRoute,
  ReportRoute,
  AdminSettingsRoute,
} from "../PageRouting";

import {
  adsBlueA,
  adsMidGreyA,
  adsLightGreyA,
  adsLightGreyB,
  adsLightGreyA50,
  adsMagenta,
  adsPaleBlueA,
  adsPaleBlueB,
  adsWhite,
} from "../utils/ADSColours";
import {
  navBarWidth,
  GetAlertStyle,
  GetAlertIcon,
  GetAlertSeverity,
  tooltipStyle,
  dataFormStyle,
} from "../utils/ADSStyles";
import { useTheme } from "@mui/material/styles";
import LoginDialog from "../dialogs/LoginDialog";
import { PostUserLogoffUrl, GetNotificationsUrl, GetAppName } from "../configuration/ADSConfig";

//endregion imports

const ADSNavContent = (props) => {
  const theme = useTheme();

  const navigate = useNavigate();
  const location = useLocation();

  const sandboxStore = useSandboxStore((state) => state);
  const sourceStreet = useSandboxStore((state) => state.sourceStreet);
  const currentStreet = useSandboxStore((state) => state.currentStreet);
  const currentDescriptorRecord = useSandboxStore((state) => state.currentDescriptorRecord);
  const currentEsuRecord = useSandboxStore((state) => state.currentEsuRecord);
  const currentHighwayDedicationRecord = useSandboxStore((state) => state.currentHighwayDedicationRecord);
  const currentOneWayExemptionRecord = useSandboxStore((state) => state.currentOneWayExemptionRecord);
  const currentMaintenanceResponsibilityRecord = useSandboxStore(
    (state) => state.currentMaintenanceResponsibilityRecord
  );
  const currentReinstatementCategoryRecord = useSandboxStore((state) => state.currentReinstatementCategoryRecord);
  const currentOSSpecialDesignationRecord = useSandboxStore((state) => state.currentOSSpecialDesignationRecord);
  const currentInterestRecord = useSandboxStore((state) => state.currentInterestRecord);
  const currentConstructionRecord = useSandboxStore((state) => state.currentConstructionRecord);
  const currentSpecialDesignationRecord = useSandboxStore((state) => state.currentSpecialDesignationRecord);
  const currentHWWRecord = useSandboxStore((state) => state.currentHWWRecord);
  const currentPRoWRecord = useSandboxStore((state) => state.currentPRoWRecord);
  const currentStreetNoteRecord = useSandboxStore((state) => state.currentStreetNoteRecord);
  const sourceProperty = useSandboxStore((state) => state.sourceProperty);
  const currentProperty = useSandboxStore((state) => state.currentProperty);
  const currentLpiRecord = useSandboxStore((state) => state.currentLpiRecord);
  const currentProvenanceRecord = useSandboxStore((state) => state.currentProvenanceRecord);
  const currentAppCrossRefRecord = useSandboxStore((state) => state.currentAppCrossRefRecord);
  const currentClassificationRecord = useSandboxStore((state) => state.currentClassificationRecord);
  const currentOrganisationRecord = useSandboxStore((state) => state.currentOrganisationRecord);
  const currentSuccessorCrossRefRecord = useSandboxStore((state) => state.currentSuccessorCrossRefRecord);
  const currentPropertyNoteRecord = useSandboxStore((state) => state.currentPropertyNoteRecord);
  const setStore = useSandboxStore((state) => state.setStore);
  const resetSandbox = useSandboxStore((state) => state.resetSandbox);

  const streetContext = useContext(StreetContext);
  const propertyContext = useContext(PropertyContext);
  const searchContext = useContext(SearchContext);
  const mapContext = useContext(MapContext);
  const lookupContext = useContext(LookupContext);
  const userContext = useContext(UserContext);
  const settingsContext = useContext(SettingsContext);
  const informationContext = useContext(InformationContext);

  const [homeActive, setHomeActive] = useState(location.pathname === HomeRoute);
  const [gazetteerActive, setGazetteerActive] = useState(
    location.pathname === GazetteerRoute ||
      location.pathname.includes(StreetRoute) ||
      location.pathname.includes(PropertyRoute)
  );
  const [taskActive, setTaskActive] = useState(location.pathname === TaskRoute);
  const [reportActive, setReportActive] = useState(location.pathname === ReportRoute);

  const [saveOpen, setSaveOpen] = useState(false);
  const saveResult = useRef(null);
  const saveType = useRef(null);
  const failedValidation = useRef(null);
  const associatedRecords = useRef([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElNotifications, setAnchorElNotifications] = useState(null);
  const settingsOpen = Boolean(anchorEl);
  const notificationsOpen = Boolean(anchorElNotifications);
  const settingsPopoverId = settingsOpen ? "ads-settings-popover" : undefined;
  const notificationsPopoverId = notificationsOpen ? "ads-notifications-popover" : undefined;
  const saveConfirmDialog = useSaveConfirmation();

  const [loginOpen, setLoginOpen] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [readNotificationIds, setReadNotificationIds] = useState([]);
  const [copiedLinkId, setCopiedLinkId] = useState(null);

  /**
   * Event to handle when the user button is clicked.
   */
  const handleUserClick = () => {
    if (userContext.currentUser && userContext.currentUser.active) {
      setAnchorEl(document.getElementById("imanage-user-settings"));
    } else {
      userContext.onDisplayLogin();
    }
  };

  /**
   * Event to handle closing the settings.
   */
  const handleSettingsClose = () => {
    setAnchorEl(null);
  };

  /**
   * Event to handle closing the notifications.
   */
  const handleNotificationsClose = () => {
    setAnchorElNotifications(null);
  };

  /**
   * Event to handle when the login dialog closes.
   */
  const handleLoginDialogClose = () => {
    setChangePassword(false);
    setLoginOpen(false);
  };

  /**
   * Method to get the settings cards.
   *
   * @returns {JSX.Element} The settings cards.
   */
  function GetSettingCards() {
    return (
      <Stack direction="row" spacing={0.5}>
        {userContext.currentUser && (
          <Card variant="outlined">
            <CardContent>
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                <Avatar {...StringAvatar(userContext.currentUser.displayName, false)} />
                {userContext.currentUser && (
                  <Typography sx={{ fontWeight: "bold" }}>{`${stringToSentenceCase(
                    userContext.currentUser.firstName
                  )} ${stringToSentenceCase(userContext.currentUser.lastName)}`}</Typography>
                )}
              </Stack>
            </CardContent>
            <CardActions>
              <Stack
                sx={{ ml: theme.spacing(2), mr: theme.spacing(2), mb: theme.spacing(2) }}
                direction="column"
                spacing={1}
                alignItems="flex-start"
              >
                {process.env.NODE_ENV === "development" && (
                  <ADSActionButton variant="user" buttonLabel="My profile" onClick={handleMyProfileClick} />
                )}
                <ADSActionButton variant="logout" buttonLabel="Log out" onClick={handleLogout} />
                <ADSActionButton variant="password" buttonLabel="Change password" onClick={handleChangePassword} />
              </Stack>
            </CardActions>
          </Card>
        )}
        {userContext.currentUser && userContext.currentUser.isAdministrator && (
          <Card variant="outlined">
            <CardContent>
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                <Avatar variant="rounded" {...StringAvatar(settingsContext ? settingsContext.authorityName : null)} />
                <Typography sx={{ fontWeight: "bold" }}>
                  {settingsContext ? settingsContext.authorityName : null}
                </Typography>
              </Stack>
            </CardContent>
            <CardActions>
              <Stack
                sx={{ ml: theme.spacing(2), mr: theme.spacing(2), mb: theme.spacing(2) }}
                direction="column"
                spacing={1}
                alignItems="flex-start"
              >
                <ADSActionButton variant="settings" buttonLabel="Settings" onClick={handleSettingsClick} />
                {process.env.NODE_ENV === "development" && (
                  <ADSActionButton
                    variant="users"
                    buttonLabel="Users & permissions"
                    onClick={handleUsersPermissionsClick}
                  />
                )}
                {process.env.NODE_ENV === "development" && (
                  <ADSActionButton variant="import" buttonLabel="Import" onClick={handleImportClick} />
                )}
                {process.env.NODE_ENV === "development" && (
                  <ADSActionButton variant="export" buttonLabel="Export" onClick={handleExportClick} />
                )}
              </Stack>
            </CardActions>
          </Card>
        )}
      </Stack>
    );
  }

  /**
   * Logic for saving notification ids that have been read.
   */
  const saveReadNotificationIds = (ids) => {
    localStorage.setItem("readNotificationIds", JSON.stringify(ids));
    setReadNotificationIds(ids);
  };

  /**
   * Logic to mark a notification by id as read.
   */
  const markNotificationAsRead = (notificationId) => {
    const updatedIds = [...readNotificationIds, notificationId];
    saveReadNotificationIds(updatedIds);
  };

  /**
   * Function to save all loaded notifications as read.
   */
  const markAllNotificationsAsRead = () => {
    const allIds = notifications.map((n) => n.id);
    const uniqueIds = [...new Set([...readNotificationIds, ...allIds])];
    saveReadNotificationIds(uniqueIds);
  };

  /**
   * Method to fetch notifications from the API.
   */
  const fetchNotifications = useCallback(async () => {
    if (!userContext.currentUser || !userContext.currentUser.token) {
      setNotifications([]);
      return;
    }

    let applicationName = GetAppName();
    if (applicationName.toLowerCase().includes("iManage")) {
      applicationName = "iManage GMS";
    }

    const apiUrl = GetNotificationsUrl(userContext.currentUser, applicationName);

    if (!apiUrl) {
      setNotifications([]);
      return;
    }

    try {
      const response = await fetch(apiUrl.url, {
        cache: "no-cache",
        headers: apiUrl.headers,
        crossDomain: true,
        method: apiUrl.type,
      });

      if (response.ok) {
        if (response.status === 200) {
          const data = await response.json();
          const now = new Date();

          const activeNotifications = data.filter((notification) => {
            const notificationOrganisations = notification.organisations || [];
            const userOrganisation =
              settingsContext?.authorityDetails?.userOrgName ||
              settingsContext?.organisationName ||
              settingsContext?.authorityName ||
              userContext?.currentUser?.organisation ||
              userContext?.currentUser?.organization ||
              null;

            if (notificationOrganisations.length > 0) {
              if (userOrganisation) {
                const matchesOrganisation = notificationOrganisations.some(
                  (org) => org && org.toLowerCase() === userOrganisation.toLowerCase()
                );

                if (!matchesOrganisation) {
                  return false;
                }
              }
            }

            const startDate = new Date(notification.startDate);
            const endDate = new Date(notification.endDate);

            const inDateRange = now >= startDate && now <= endDate;
            if (!inDateRange) {
              return false;
            }

            return true;
          });

          setNotifications(activeNotifications);
        } else if (response.status === 204) {
          setNotifications([]);
        }
      } else if (response.status === 401) {
        if (userContext.currentUser && userContext.currentUser.showMessages) {
          console.error("[NOTIFICATIONS] Unauthorized (401)");
        }
        userContext.onExpired();
        setNotifications([]);
      } else {
        if (userContext.currentUser.showMessages) {
          console.error("[NOTIFICATIONS] Failed to fetch notifications", response.status, response.statusText);
        }
        setNotifications([]);
      }
    } catch (error) {
      if (userContext.currentUser && userContext.currentUser.showMessages) {
        console.error("[NOTIFICATIONS] Failed to fetch notifications", error);
      }
      setNotifications([]);
    }
  }, [userContext, settingsContext?.authorityDetails?.userOrgName, settingsContext?.organisationName, settingsContext?.authorityName]);

  const fetchNotificationsRef = useRef(fetchNotifications);
  useEffect(() => {
    fetchNotificationsRef.current = fetchNotifications;
  }, [fetchNotifications]);

  const getUnreadCount = () => {
    return notifications.filter((notification) => !readNotificationIds.includes(notification.id)).length;
  };
  /**
   * Method to get the notifications cards.
   *
   * @returns {JSX.Element} The notifications cards.
   */
  function GetNotificationsCard() {
    const unreadCount = getUnreadCount();
    return (
      <Stack direction="row" spacing={0.5} width={440}>
        {userContext.currentUser && (
          <Card variant="outline" sx={{ width: "100%" }}>
            <Box>
              <Stack variant="subtitle2" textAlign="left" fontSize={18}>
                <CardContent sx={{ mt: theme.spacing(0.5), p: theme.spacing(0.5), pl: theme.spacing(2) }}>
                  Notifications
                  <Typography
                    right={theme.spacing(2)}
                    position={"absolute"}
                    top={theme.spacing(1.5)}
                    fontSize={12}
                    sx={{
                      color: unreadCount > 0 ? adsBlueA : adsLightGreyA,
                      cursor: unreadCount > 0 ? "pointer" : "default",
                      pointerEvents: unreadCount > 0 ? "auto" : "none",
                      display: "flex",
                      alignItems: "center",
                      gap: theme.spacing(0.25),
                    }}
                    onClick={markAllNotificationsAsRead}
                  >
                    <CheckIcon sx={{ fontSize: "12px" }} />
                    Mark all as read
                  </Typography>
                </CardContent>

                <Stack direction="column" alignItems="left">
                  {[...notifications]
                    .sort((a, b) => {
                      const dateA = new Date(a.startDate);
                      const dateB = new Date(b.startDate);
                      return dateB - dateA;
                    })
                    .map((data) => {
                      const isUnread = !readNotificationIds.includes(data.id);
                      return (
                        <NotificationMessageHolder
                          key={data.id}
                          id={data.id}
                          message={data.message}
                          title={data.title}
                          date={data.startDate}
                          unread={isUnread}
                          importance={data.importance}
                          link={data.link}
                          onMarkAsRead={markNotificationAsRead}
                        />
                      );
                    })}

                  {!notifications.length && <NotificationMessageHolder message={"No notifications"} />}
                </Stack>
              </Stack>
            </Box>
          </Card>
        )}
      </Stack>
    );
  }

  const formatNotificationTimestamp = (dateValue) => {
    if (!dateValue) return "";

    const notificationDate = new Date(dateValue);
    if (Number.isNaN(notificationDate.getTime())) return "";

    const now = new Date();
    const isToday =
      notificationDate.getDate() === now.getDate() &&
      notificationDate.getMonth() === now.getMonth() &&
      notificationDate.getFullYear() === now.getFullYear();

    const formattedTime = FormatTime(notificationDate).replace(/\s(?=[AaPp][Mm]$)/, "");

    if (isToday) return formattedTime;

    const day = notificationDate.getDate();
    const weekday = notificationDate.toLocaleDateString("en-GB", { weekday: "short" });
    const getDaySuffix = (dayNumber) => {
      if (dayNumber >= 11 && dayNumber <= 13) return "th";
      switch (dayNumber % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${weekday}, ${day}${getDaySuffix(day)} ${formattedTime}`;
  };

  const NotificationMessageHolder = (props) => {
    const handleClick = () => {
      if (props.id && props.unread && props.onMarkAsRead) {
        props.onMarkAsRead(props.id);
      }
    };

    const handleCopyLink = async (event) => {
      event.stopPropagation();
      if (!props.link) return;

      try {
        await navigator.clipboard.writeText(props.link);
        setCopiedLinkId(props.id);
        setTimeout(() => setCopiedLinkId(null), 2000);
      } catch (error) {}
    };

    const isNoNotifications = !props.id && props.message === "No notifications";

    return (
      <Grid
        sx={{
          background: props.unread ? adsPaleBlueA : adsWhite,
          cursor: isNoNotifications ? "default" : "pointer",
          padding: theme.spacing(2),
          width: "100%",
          borderTop: `1px solid ${adsLightGreyB}`,
          "&:hover": isNoNotifications ? {} : { background: props.unread ? adsPaleBlueB : adsLightGreyB },
        }}
        onClick={handleClick}
      >
        <Stack direction="row" alignItems="flex-start" spacing={2} sx={{ width: "100%" }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              component="div"
              sx={{
                fontSize: 14,
                fontWeight: 400,
                color: adsMidGreyA,
                lineHeight: 1.25,
                opacity: 1,
              }}
            >
              {props.title && (
                <Box component="span" sx={{ fontWeight: 600 }}>
                  {props.title}
                </Box>
              )}
              {props.title && props.message && " "}
              {props.message}
            </Typography>
            {props.link && (
              <Stack direction="row" spacing={0.25} alignItems="center" sx={{ mt: theme.spacing(0.75) }}>
                <Typography
                  component="a"
                  href={props.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(event) => event.stopPropagation()}
                  sx={{
                    color: adsBlueA,
                    textDecoration: "underline",
                    fontSize: 12,
                    fontWeight: 400,
                    overflowWrap: "anywhere",
                  }}
                >
                  {props.link}
                </Typography>
                <Tooltip title={copiedLinkId === props.id ? "Copied" : "Copy link"}>
                  <IconButton
                    size="small"
                    onClick={handleCopyLink}
                    sx={{ p: "2px" }}
                    aria-label={`Copy notification link for ${props.title || "notification"}`}
                  >
                    <ContentCopyIcon sx={{ color: adsMidGreyA, fontSize: "14px" }} />
                  </IconButton>
                </Tooltip>
              </Stack>
            )}
            <Typography
              component="div"
              variant="subtitle2"
              sx={{ mt: theme.spacing(0.5), fontWeight: 400, color: adsMidGreyA, fontSize: 12, opacity: 1 }}
            >
              {formatNotificationTimestamp(props.date)}
            </Typography>
          </Box>
          {props.id && (
            <Box sx={{ flexShrink: 0, pt: theme.spacing(0.25) }}>
              <CircleIcon
                sx={{
                  width: 10,
                  height: 10,
                  color: props.unread ? adsMagenta : adsLightGreyA,
                  display: "block",
                }}
              />
            </Box>
          )}
        </Stack>
      </Grid>
    );
  };

  /**
   * Method to set the currently active button.
   */
  const setActiveButton = () => {
    setHomeActive(location.pathname === HomeRoute);
    setGazetteerActive(
      location.pathname === GazetteerRoute ||
        location.pathname.includes(StreetRoute) ||
        location.pathname.includes(PropertyRoute)
    );
    setTaskActive(location.pathname === TaskRoute);
    setReportActive(location.pathname === ReportRoute);
  };

  /**
   * Event to handle th closing of the property save alert.
   *
   * @param {object} event The event object.
   * @param {string} reason The reason the alert is closing.
   * @returns
   */
  const handlePropertySaveClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSaveOpen(false);
  };

  /**
   * Event to handle saving the street.
   *
   * @param {object} currentStreet The data for the current street.
   * @param {boolean} resetRequired True if all the contexts need to be reset; otherwise false.
   * @param {string} page The page we are changing to.
   */
  function HandleSaveStreet(currentStreet, resetRequired, page) {
    SaveStreet(
      currentStreet,
      streetContext,
      userContext,
      lookupContext,
      searchContext,
      mapContext,
      sandboxStore,
      settingsContext.isScottish,
      settingsContext.isWelsh
    ).then((result) => {
      if (result.street) {
        saveResult.current = true;
        saveType.current = "street";
        setSaveOpen(true);
        if (resetRequired) {
          ResetContexts("street", mapContext, streetContext, propertyContext);
          resetSandbox("street");
        } else {
          streetContext.resetStreetErrors();
          setStore(result.store);
        }
        GoToPage(page);
      } else {
        saveResult.current = false;
        saveType.current = "street";
        setSaveOpen(true);
      }
    });
  }

  /**
   * Event to handle saving the property.
   *
   * @param {object} currentProperty The data for the current property.
   * @param {boolean} resetRequired True if all the contexts need to be reset; otherwise false.
   * @param {string} page The page we are changing to.
   * @param {boolean} cascadeParentPaoChanges If true the child property PAO details need to be changed; otherwise they are not changed.
   * @param {boolean} cascadeMove True if the changes to the property location need to be cascaded down to the children; otherwise false.
   */
  function HandleSaveProperty(currentProperty, resetRequired, page, cascadeParentPaoChanges, cascadeMove) {
    SavePropertyAndUpdate(
      currentProperty,
      propertyContext.currentProperty.newProperty,
      propertyContext,
      userContext,
      searchContext,
      mapContext,
      sandboxStore,
      settingsContext.isScottish,
      settingsContext.isWelsh,
      cascadeParentPaoChanges,
      cascadeMove
    ).then((result) => {
      if (result.property) {
        saveResult.current = true;
        saveType.current = "property";
        setSaveOpen(true);
        if (resetRequired) {
          ResetContexts("property", mapContext, streetContext, propertyContext);
          resetSandbox("property");
        } else propertyContext.resetPropertyErrors(propertyContext.creatingPropertyRange, true);
        GoToPage(page);
      } else {
        saveResult.current = false;
        saveType.current = "property";
        setSaveOpen(true);
      }
    });
  }

  /**
   * Method to change the current page.
   *
   * @param {string} page The page we want to go to.
   */
  const GoToPage = (page) => {
    informationContext.onClearInformation();

    switch (page) {
      case "gazetteer":
        handleGazetteerClick();
        break;

      case "task":
        handleTaskManagementClick();
        break;

      case "report":
        handleReportsClick();
        break;

      case "whatsNew":
        handleWhatsNewClick();
        break;

      case "notification":
        handleNotificationClick();
        break;

      case "user":
        handleUserClick();
        break;

      default:
        // Home
        handleHomeClick();
        break;
    }
  };

  /**
   * Event to handle when the page changes.
   *
   * @param {string} page The page we are changing to.
   */
  const handlePageChangeClick = (page) => {
    const resetRequired = ["gazetteer", "home"].includes(page);
    if (sourceStreet) {
      const streetChanged = HasStreetChanged(
        streetContext.currentStreet.newStreet,
        sourceStreet,
        currentDescriptorRecord,
        currentEsuRecord,
        currentHighwayDedicationRecord,
        currentOneWayExemptionRecord,
        currentMaintenanceResponsibilityRecord,
        currentReinstatementCategoryRecord,
        currentOSSpecialDesignationRecord,
        currentInterestRecord,
        currentConstructionRecord,
        currentSpecialDesignationRecord,
        currentHWWRecord,
        currentPRoWRecord,
        currentStreetNoteRecord,
        currentStreet,
        userContext.currentUser && userContext.currentUser.hasASD
      );

      if (streetChanged) {
        associatedRecords.current = getChangedAssociatedStreetRecords(
          sourceStreet,
          currentDescriptorRecord,
          currentEsuRecord,
          currentHighwayDedicationRecord,
          currentOneWayExemptionRecord,
          currentMaintenanceResponsibilityRecord,
          currentReinstatementCategoryRecord,
          currentOSSpecialDesignationRecord,
          currentInterestRecord,
          currentConstructionRecord,
          currentSpecialDesignationRecord,
          currentHWWRecord,
          currentPRoWRecord,
          currentStreetNoteRecord,
          currentStreet,
          streetContext.esuDataChanged
        );

        const streetData = currentStreet ? currentStreet : sourceStreet;

        if (associatedRecords.current.length > 0) {
          saveConfirmDialog(associatedRecords.current)
            .then((result) => {
              if (result === "save") {
                if (streetContext.validateData()) {
                  failedValidation.current = false;
                  const currentStreetData = GetCurrentStreetData(
                    streetData,
                    currentDescriptorRecord,
                    currentEsuRecord,
                    currentStreetNoteRecord,
                    currentMaintenanceResponsibilityRecord,
                    currentReinstatementCategoryRecord,
                    currentOSSpecialDesignationRecord,
                    currentInterestRecord,
                    currentConstructionRecord,
                    currentSpecialDesignationRecord,
                    currentHWWRecord,
                    currentPRoWRecord,
                    lookupContext,
                    settingsContext.isWelsh,
                    settingsContext.isScottish,
                    userContext.currentUser && userContext.currentUser.hasASD
                  );
                  HandleSaveStreet(currentStreetData, resetRequired, page);
                } else {
                  failedValidation.current = true;
                  saveResult.current = false;
                  setSaveOpen(true);
                }
              }
              if (resetRequired) {
                ResetContexts("street", mapContext, streetContext, propertyContext);
                resetSandbox("street");
              } else streetContext.resetStreetErrors();
              GoToPage(page);
            })
            .catch(() => {});
        } else {
          saveConfirmDialog(true)
            .then((result) => {
              if (result === "save") {
                HandleSaveStreet(currentStreet, resetRequired, page);
              } else {
                if (resetRequired) {
                  ResetContexts("street", mapContext, streetContext, propertyContext);
                  resetSandbox("street");
                } else streetContext.resetStreetErrors();
                GoToPage(page);
              }
            })
            .catch(() => {});
        }
      } else {
        if (resetRequired) {
          ResetContexts("street", mapContext, streetContext, propertyContext);
          resetSandbox("street");
        } else streetContext.resetStreetErrors();
        GoToPage(page);
      }
    } else if (sourceProperty) {
      const propertyChanged = HasPropertyChanged(
        propertyContext.currentProperty.newProperty,
        sourceProperty,
        currentLpiRecord,
        currentProvenanceRecord,
        currentAppCrossRefRecord,
        currentClassificationRecord,
        currentOrganisationRecord,
        currentSuccessorCrossRefRecord,
        currentPropertyNoteRecord,
        currentProperty
      );

      if (propertyChanged) {
        associatedRecords.current = getChangedAssociatedPropertyRecords(
          sourceProperty,
          currentLpiRecord,
          currentProvenanceRecord,
          currentAppCrossRefRecord,
          currentClassificationRecord,
          currentOrganisationRecord,
          currentSuccessorCrossRefRecord,
          currentPropertyNoteRecord
        );

        const parentPaoChanged = hasParentPaoChanged(
          propertyContext.childCount,
          sourceProperty,
          currentProperty,
          associatedRecords.current.length > 0 && associatedRecords.current.includes("LPI") ? currentLpiRecord : null
        );

        const parentMoved = hasParentMoved(propertyContext.childCount, sourceProperty, currentProperty);

        const propertyData = currentProperty ? currentProperty : sourceProperty;

        if (associatedRecords.current.length > 0) {
          saveConfirmDialog(associatedRecords.current, parentPaoChanged, parentMoved)
            .then((result) => {
              if (result === "save" || result === "saveCascade") {
                if (propertyContext.validateData()) {
                  failedValidation.current = false;
                  const currentPropertyData = GetCurrentPropertyData(
                    propertyData,
                    currentLpiRecord,
                    currentProvenanceRecord,
                    currentAppCrossRefRecord,
                    currentClassificationRecord,
                    currentOrganisationRecord,
                    currentSuccessorCrossRefRecord,
                    currentPropertyNoteRecord,
                    lookupContext,
                    settingsContext.isWelsh,
                    settingsContext.isScottish
                  );
                  HandleSaveProperty(
                    currentPropertyData,
                    resetRequired,
                    page,
                    result === "saveCascade" || result === "saveCascadeMove",
                    result === "saveCascadeMove" || result === "saveMove"
                  );
                } else {
                  failedValidation.current = true;
                  saveResult.current = false;
                  setSaveOpen(true);
                }
              } else {
                if (resetRequired) {
                  ResetContexts("property", mapContext, streetContext, propertyContext);
                  resetSandbox("property");
                } else propertyContext.resetPropertyErrors(propertyContext.creatingPropertyRange, true);
                GoToPage(page);
              }
            })
            .catch(() => {});
        } else {
          saveConfirmDialog(true, parentPaoChanged, parentMoved)
            .then((result) => {
              if (result === "save" || result === "saveCascade") {
                HandleSaveProperty(
                  currentProperty,
                  resetRequired,
                  page,
                  result === "saveCascade" || result === "saveCascadeMove",
                  result === "saveCascadeMove" || result === "saveMove"
                );
              } else {
                if (resetRequired) {
                  ResetContexts("property", mapContext, streetContext, propertyContext);
                  resetSandbox("property");
                } else propertyContext.resetPropertyErrors(propertyContext.creatingPropertyRange, true);
                GoToPage(page);
              }
            })
            .catch(() => {});
        }
      } else {
        if (resetRequired) {
          ResetContexts("property", mapContext, streetContext, propertyContext);
          resetSandbox("property");
        } else propertyContext.resetPropertyErrors(propertyContext.creatingPropertyRange, true);
        GoToPage(page);
      }
    } else {
      if (resetRequired) {
        ResetContexts("all", mapContext, streetContext, propertyContext);
        resetSandbox("all");
      } else {
        streetContext.resetStreetErrors();
        propertyContext.resetPropertyErrors(true);
      }
      GoToPage(page);
    }
  };

  /**
   * Event to handle when the home button is clicked.
   */
  const handleHomeClick = () => {
    streetContext.resetStreet();
    propertyContext.resetProperty();
    navigate(HomeRoute);
    setActiveButton();
  };

  /**
   * Event to handle when the gazetteer button is clicked.
   */
  const handleGazetteerClick = () => {
    if (
      !searchContext.currentSearchData.searchString ||
      searchContext.currentSearchData.searchString === "!+reload+!"
    ) {
      searchContext.onSearchDataChange(blankGazetteerSearchString, []);
      mapContext.onSearchDataChange([], [], [], null, null);
      mapContext.onBackgroundDataChange([], [], [], []);
      mapContext.onViewAuthorityExtent(true);
    } else if (searchContext.currentSearchData.searchString === blankGazetteerSearchString) {
      mapContext.onSearchDataChange([], [], [], null, null);
      mapContext.onBackgroundDataChange([], [], [], []);
      mapContext.onViewAuthorityExtent(true);
    }
    navigate(GazetteerRoute);
    setActiveButton();
  };

  /**
   * Event to handle when the task management button is clicked.
   */
  const handleTaskManagementClick = () => {
    navigate(TaskRoute);
    setActiveButton();
  };

  /**
   * Event to handle when the reports button is clicked.
   */
  const handleReportsClick = () => {
    navigate(ReportRoute);
    setActiveButton();
  };

  /**
   * Event to handle when the notification button is clicked.
   */
  const handleNotificationClick = () => {
    informationContext.onClearInformation();
    if (userContext.currentUser && userContext.currentUser.active) {
      setAnchorElNotifications(document.getElementById("imanage-user-settings"));
    } else {
      userContext.onDisplayLogin();
    }
  };

  /**
   * Event to handle when the what's new button is clicked.
   */
  const handleWhatsNewClick = () => {
    informationContext.onClearInformation();
  };

  /**
   * Event to handle when the my profile button is clicked.
   */
  const handleMyProfileClick = () => {
    informationContext.onClearInformation();
  };

  /**
   * Event to handle logging out of the system.
   */
  const handleLogout = async () => {
    const apiUrl = PostUserLogoffUrl(userContext.currentUser.token);
    if (apiUrl) {
      const logoffResult = await fetch(`${apiUrl.url}`, {
        cache: "no-cache",
        headers: apiUrl.headers,
        crossDomain: true,
        method: apiUrl.type,
      })
        .then((res) => (res.ok ? res : Promise.reject(res)))
        .then((res) => res.text())
        .then((result) => {
          return "Logged off";
        })
        .catch((error) => {
          if (userContext.currentUser.showMessages) {
            console.error("[ERROR] User logoff", error);
          }
          return null;
        });

      if (!!logoffResult) {
        setAnchorEl(null);
        handleHomeClick();
        informationContext.onClearInformation();
        userContext.onUserChange(null);
        window.location.reload();
      }
    }
  };

  /**
   * Event to handle logging out of the system.
   */
  const handleChangePassword = () => {
    setAnchorEl(null);
    informationContext.onClearInformation();
    setChangePassword(true);
    setLoginOpen(true);
  };

  /**
   * Method to display the administrator settings page.
   *
   * @param {number} initialNodeId The initial node to be displayed.
   */
  const displayAdminSettingsPage = (initialNodeId) => {
    setAnchorEl(null);
    settingsContext.onNodeChange(initialNodeId);
    navigate(AdminSettingsRoute);
    setActiveButton();
  };

  /**
   * Event to handle when the settings button is clicked.
   */
  const handleSettingsClick = () => {
    displayAdminSettingsPage(userContext.currentUser && userContext.currentUser.hasProperty ? "2.1" : "2.2");
  };

  /**
   * Event to handle when the users permissions button is clicked.
   */
  const handleUsersPermissionsClick = () => {
    displayAdminSettingsPage("3.0");
  };

  /**
   * Event to handle when the import button is clicked.
   */
  const handleImportClick = () => {};

  /**
   * Event to handle when the export button is clicked.
   */
  const handleExportClick = () => {};

  /**
   * Method to get the navigation icon styling.
   *
   * @param {boolean} open True if the navigation group is open; otherwise false.
   * @returns {object} The styling for the navigation icon.
   */
  function navigationIconStyle(open) {
    if (open) return { color: adsBlueA };
    else return { color: adsMidGreyA };
  }

  useEffect(() => {
    setActiveButton();
  });

  useEffect(() => {
    const loadReadNotificationIds = () => {
      try {
        const stored = localStorage.getItem("readNotificationIds");
        if (stored) {
          return JSON.parse(stored);
        }
      } catch (error) {
        if (userContext.currentUser && userContext.currentUser.showMessages) {
          console.error("[ERROR] Failed to load read notification IDs", error);
        }
      }
      return [];
    };

    const storedIds = loadReadNotificationIds();
    setReadNotificationIds(storedIds);
  }, [userContext.currentUser]);

  useEffect(() => {
    const fetchIfLoggedIn = async () => {
      if (userContext.currentUser?.token) {
        await fetchNotificationsRef.current();
      } else {
        setNotifications([]);
      }
    };

    fetchIfLoggedIn();
    // Set an interval to refresh notifications every 30 minutes
    const interval = setInterval(fetchIfLoggedIn, 30 * 60 * 1000);

    return () => clearInterval(interval);
  }, [userContext.currentUser?.token]);

  return (
    <Fragment>
      <Drawer
        sx={{
          width: `${navBarWidth}px`,
          borderRight: "1px",
          borderRightColor: adsLightGreyB,
          boxShadow: `4px 0px 9px ${adsLightGreyA50}`,
        }}
        variant="permanent"
        anchor="left"
      >
        <Grid
          sx={dataFormStyle("ADSNavContent")}
          container
          direction="column"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid>
            <Grid container direction="column" alignItems="center" justifyContent="flex-start">
              <Grid sx={{ mb: theme.spacing(2) }} size="grow">
                <img sx={{ ml: theme.spacing(2) }} src="/images/Idox_Logo.svg" alt="Idox" width="36" />
              </Grid>
              <Grid size="grow">
                <Tooltip title="Home" arrow placement="right" sx={tooltipStyle}>
                  <IconButton aria-label="home" onClick={() => handlePageChangeClick("home")} size="large">
                    <DashboardIcon fontSize="large" sx={navigationIconStyle(homeActive)} />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid size="grow">
                <Tooltip title="Gazetteer" arrow placement="right" sx={tooltipStyle}>
                  <IconButton aria-label="gazetteer" onClick={() => handlePageChangeClick("gazetteer")} size="large">
                    <ExploreIcon fontSize="large" sx={navigationIconStyle(gazetteerActive)} />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid size="grow">
                {process.env.NODE_ENV === "development" && (
                  <Tooltip title="Task management" arrow placement="right" sx={tooltipStyle}>
                    <span>
                      <IconButton
                        aria-label="task management"
                        disabled
                        onClick={() => handlePageChangeClick("task")}
                        size="large"
                      >
                        <AssignmentTurnedInIcon fontSize="large" sx={navigationIconStyle(taskActive)} />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </Grid>
              <Grid size="grow">
                {process.env.NODE_ENV === "development" && (
                  <Tooltip title="Reports" arrow placement="right" sx={tooltipStyle}>
                    <span>
                      <IconButton
                        aria-label="reports"
                        disabled
                        onClick={() => handlePageChangeClick("report")}
                        size="large"
                      >
                        <InsertChartIcon fontSize="large" sx={navigationIconStyle(reportActive)} />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            <Grid container direction="column" alignItems="center" justifyContent="flex-end">
              {process.env.NODE_ENV === "development" && (
                <ADSWhatsNewAvatar count={0} handleClick={() => handlePageChangeClick("whatsNew")} />
              )}
              <ADSNotificationsAvatar
                count={getUnreadCount()}
                handleClick={() => handlePageChangeClick("notification")}
              />
              <ADSUserAvatar onUserClick={() => handlePageChangeClick("user")} />
            </Grid>
          </Grid>
        </Grid>
      </Drawer>
      <div>
        <Snackbar
          open={saveOpen}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          onClose={handlePropertySaveClose}
        >
          <Alert
            sx={GetAlertStyle(saveResult.current)}
            icon={GetAlertIcon(saveResult.current)}
            onClose={handlePropertySaveClose}
            severity={GetAlertSeverity(saveResult.current)}
            elevation={6}
            variant="filled"
          >{`${
            saveResult.current
              ? `The ${saveType.current} has been successfully saved.`
              : failedValidation.current
                ? `Failed to validate the ${saveType.current} record.`
                : `Failed to save the ${saveType.current}.`
          }`}</Alert>
        </Snackbar>
        <Popover
          id={settingsPopoverId}
          open={settingsOpen}
          anchorEl={anchorEl}
          onClose={handleSettingsClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          {GetSettingCards()}
        </Popover>

        <Popover
          id={notificationsPopoverId}
          open={notificationsOpen}
          anchorEl={anchorElNotifications}
          onClose={handleNotificationsClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          {GetNotificationsCard()}
        </Popover>

        <LoginDialog
          isOpen={loginOpen}
          title="Change Password"
          message=""
          changePassword={changePassword}
          onClose={handleLoginDialogClose}
        />
      </div>
    </Fragment>
  );
};

ADSNavContent.propTypes = {};

export default ADSNavContent;
